const CROSSHAIR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 8v-2a2 2 0 0 1 2 -2h2"/><path d="M4 16v2a2 2 0 0 0 2 2h2"/><path d="M16 4h2a2 2 0 0 1 2 2v2"/><path d="M16 20h2a2 2 0 0 0 2 -2v-2"/><path d="M9 12l6 0"/><path d="M12 9l0 6"/></svg>`;

export default class LocationControl {
    constructor(options = {}) {
        this.onToggle = options.onToggle || (() => {});
        this.isActive = false;
    }

    onAdd() {
        this.container = document.createElement('div');
        this.container.classList.add('mapboxgl-ctrl', 'mapboxgl-ctrl-group', 'mapboxgl-ctrl-location');

        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.title = 'Track location';
        this.button.innerHTML = CROSSHAIR_SVG;
        let suppressClick = false;
        const handleToggle = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.onToggle(!this.isActive);
        };
        this.button.addEventListener('touchend', (event) => {
            suppressClick = true;
            handleToggle(event);
            setTimeout(() => {
                suppressClick = false;
            }, 300);
        }, { passive: false });
        this.button.addEventListener('click', (event) => {
            if (suppressClick) {
                return;
            }
            handleToggle(event);
        });

        this.container.appendChild(this.button);
        return this.container;
    }

    onRemove() {
        this.container.parentNode.removeChild(this.container);
    }

    setActive(active) {
        this.isActive = active;
        this.button.classList.toggle('active', active);
    }
}
